import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Flag, Tag, ChevronRight } from 'lucide-react'
import { useAuthStore } from '@/store/auth.store'

function HubTile({ to, icon, label, description }: { to: string; icon: React.ReactNode; label: string; description: string }) {
  return (
    <Link
      to={to}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '14px 16px',
        background: 'var(--surface)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        textDecoration: 'none',
      }}
    >
      <div
        style={{
          flexShrink: 0,
          width: 40,
          height: 40,
          borderRadius: 'var(--radius-md)',
          background: 'var(--brand-soft)',
          color: 'var(--brand)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 700, fontSize: 'var(--fs-body)', color: 'var(--text-strong)' }}>
          {label}
        </div>
        <div style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-sm)', color: 'var(--text-muted)' }}>
          {description}
        </div>
      </div>
      <ChevronRight size={18} color="var(--text-faint)" />
    </Link>
  )
}

export function AdminDashboardPage() {
  const { t } = useTranslation()
  const { hasCapability } = useAuthStore()

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <div style={{ position: 'sticky', top: 0, zIndex: 10, padding: '14px 16px', borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
        <h1 style={{ margin: 0, fontFamily: 'var(--font-sans)', fontWeight: 700, fontSize: 'var(--fs-body-lg)', color: 'var(--text-strong)' }}>
          {t('admin.title')}
        </h1>
      </div>

      <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <HubTile
          to="/admin/reports"
          icon={<Flag size={20} />}
          label={t('admin.hub_moderation')}
          description={t('admin.hub_moderation_desc')}
        />
        {hasCapability('manage_categories') && (
          <HubTile
            to="/admin/categories"
            icon={<Tag size={20} />}
            label={t('admin.hub_categories')}
            description={t('admin.hub_categories_desc')}
          />
        )}
      </div>
    </div>
  )
}
